module.exports = __webpack_public_path__ + "img/feature-reviewplatforms-2.5f455d78.jpg";